import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  header: {
    marginTop: 80,
    marginBottom: 56,
    [theme.breakpoints.down("sm")]: {
      marginTop: 40,
      marginBottom: 32,
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  title: {
    marginBottom: 18,
  },
}));

const CancerLastHeader = ({ cancer = "폐암", sub = false }) => {
  const classes = useStyles();
  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      direction="column"
      className={classes.header}
    >
      <Typography variant="h2" className={classes.title}>
        {cancer}검진을 받아야 할지 결정하기
      </Typography>
      {sub && (
        <Typography variant="h4" color="textSecondary" align="center">
          검진을 받을지 결정하는데 중요한 각 항목에 대해
          <br />
          귀하께서 얼마나 중요하게 여기는지 스스로 체크해보겠습니다.
        </Typography>
      )}
    </Grid>
  );
};

export default CancerLastHeader;
